import { render, staticRenderFns } from "./EsopTabs.vue?vue&type=template&id=1d848d4a&scoped=true&"
import script from "./EsopTabs.vue?vue&type=script&lang=js&"
export * from "./EsopTabs.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d848d4a",
  null
  
)

export default component.exports